const defaultLinkProps = `target="_blank" rel="noopener noreferrer" class="no-underline"`

export const ruleConstant = [
  {
    title: "เอกสารที่จำเป็นต้องดาวน์โหลดไปใช้",
    contents: [
      `ใบตอบรับผู้ปกครองค่ายลานเกียร์ ครั้งที่ ${process.env.REACT_APP_CAMP_YEAR} <span><a href='/assets/file/ใบตอบรับผู้ปกครอง.pdf' ${defaultLinkProps}>ดาวน์โหลด</a></span>`
    ]
  },
  {
    title: "เอกสารที่ต้องแนบเพิ่มเติม",
    contents: [
      "รูปถ่ายหน้าตรง เห็นหน้าชัดเจน เช่นรูปติดบัตร (.jpg / .png)",
      `ใบตอบรับผู้ปกครองค่ายลานเกียร์ ครั้งที่ ${process.env.REACT_APP_CAMP_YEAR} (.pdf / .jpg / .png)`,
      `ใบปพ.1 (หนังสือรับรองผลการเรียน) หรือ ปพ.7 (ใบรับรองสถานภาพการศึกษา) ที่ตรงตามเงื่อนไขตามที่ทางค่ายกำหนด (อ่านเพิ่มเติมได้ที่ <span><a href='/faq' ${defaultLinkProps}>แถบคำถามที่พบบ่อย</a></span>) (.pdf / .jpg / .png)`
    ]
  },
  {
    title: "ขั้นตอนการสมัคร",
    contents: [
      "กรอกข้อมูลส่วนตัว การศึกษา สุขภาพ และช่องทางการติดต่อ",
      "ตอบคำถามที่พี่ ๆ เตรียมไว้ให้",
      "อัปโหลดเอกสารดังที่กล่าวไว้ข้างต้น",
      "ยืนยันการสมัคร",
      `หมั่นตรวจสอบสถานะเอกสาร โดยการกดที่รูป Profile (มุมขวาบน) → <a href='/profile' ${defaultLinkProps}>สถานะการสมัคร</a>`,
      `กดติดตาม Facebook Page: <a href='https://www.facebook.com/LARNGEARCAMP/' ${defaultLinkProps}>LarnGear Camp</a> หรือ IG: <a href='https://www.instagram.com/larngear_camp/' ${defaultLinkProps}>larngear_camp</a> เพื่อติดตามประกาศอย่างใกล้ชิด`
    ]
  }
]
